import React, { useEffect, useState } from "react";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import request from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import { getSalestargetDetailByUser } from "../grphql";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import TableComponent from "../../../components/GridTable/TableComponent";

const EmployeeTargetList = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const productListTable = {
    columns: [
      {
        label: "S.No.",
        field: "sno",
        // flex: 1,
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },

      {
        label: "Employee Name",
        field: "user",
        name: "Product Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Year Target",
        field: "salesTarget",
        name: "Product ID",
        // flex: 1,
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Target",
        field: "targetAmount",
        name: "Product ID",
        // flex: 1,
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Action",
        field: "action",
        name: "Created By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: data.reverse().map((item, index) => ({
      sno: index + 1,
      id: currentUser?.id,
      user: item.user.username,
      salesTarget: item.salesTarget.financialYear,
      targetAmount: item.targetAmount,
      action: (
        <>
          <Tooltip
            onClick={() => handleEmployeeView(item.id)}
            sx={{ cursor: "pointer" }}
            title="View Target"
          >
            <RemoveRedEyeIcon />
          </Tooltip>
        </>
      ),
      //   productName: item.productName,
      //   categoryName: item.category.categoryName,
      //   brandName: item.brand.brandName,
      //   productCost: item.productCost,
      //   createdBy: item.user.username,
    })),
  };

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const res = await request(BASEURL, getSalestargetDetailByUser, {
          id: currentUser?.id,
        });
        setData(res?.getSalestargetDetailByUser);
      } catch (err) {
      } finally {
      }
    };
    fetchdata();
  }, []);

  const handleEmployeeView = (id) => {
    navigate(`/SalesTarget/showTarget?${currentUser?.id}`);
  };

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }

  const onDeleteALL=()=>
      {
        console.log("id-DELE")
      }
  const onDelete=(id)=>
        {
          console.log("id-d",id)
        }
  return (
    <>
    <TableComponent
    columns={productListTable.columns}
    rowsData={productListTable.rows}
    styles={{ paper: { padding: '16px' } }}
    head="Employee Target List"
    actions={false}
    checked={false}
    view={true}
    showAdd = {false}
    onCheck={onCheck}
    // onEdit={onOpportunityTypeListClick}
    onDelete={onDelete}
    // onView={onOpportunityTypeListClick}
    onDeleteALL={onDeleteALL}
    // addList={() => handleNewOpportunityType()}
    />
    {/* <MaterialDataGrid
      rows={productListTable.rows}
      columns={productListTable.columns}
      //  onRowClick={onLeadAndProscpectClick}
      // onRowClick={(data)=>handleRowClick(data)}
    /> */}
    </>
  );
};

export default EmployeeTargetList;
